/**
 * Links with image: mobile links swap the featured image.
 */
(() => {
  function setup(section) {
    const imagesRoot = section.querySelector(".links-with-image__mobile-images");
    const linksRoot = section.querySelector(".links-with-image__mobile-links");
    if (!imagesRoot || !linksRoot || linksRoot.dataset.ready === "true") return;

    linksRoot.dataset.ready = "true";

    const links = Array.from(linksRoot.querySelectorAll("[data-block-id]"));

    function select(blockId) {
      links.forEach((link) => {
        const on = link.getAttribute("data-block-id") === blockId;
        link.classList.toggle("is-selected", on);
        if (on) {
          link.setAttribute("aria-current", "true");
        } else {
          link.removeAttribute("aria-current");
        }
      });

      const toImage = imagesRoot.querySelector(`[data-image-block-id="${blockId}"]`);
      if (!toImage) return;

      imagesRoot.querySelectorAll("[data-image-block-id]").forEach((image) => {
        const on = image === toImage;
        image.classList.toggle("opacity-0", !on);
        image.classList.toggle("visibility-hidden", !on);
      });
    }

    links.forEach((link) => {
      link.addEventListener("click", (event) => {
        const href = link.getAttribute("href") || "";
        if (href === "" || href === "#" || href === "#!") {
          event.preventDefault();
        }

        select(link.getAttribute("data-block-id"));
      });
    });

    if (Shopify.designMode) {
      section.addEventListener("shopify:block:select", (event) => {
        const blockId = event.target?.getAttribute("data-block-id");
        if (blockId) select(blockId);
      });
    }
  }

  function init(root = document) {
    if (root.matches?.(".shopify-section--links-with-image")) {
      setup(root);
    }

    root.querySelectorAll?.(".shopify-section--links-with-image").forEach(setup);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => init(), { once: true });
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", (event) => init(event.target));
})();
